import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { ObjectTargetsTranslator } from "./ObjectTargetsTranslator";
import { LinkedPageObjectTranslator } from "./LinkedPageObjectTranslator";

export class EmptyAlertAllowBehaviorTranslator extends ObjectTargetsTranslator<ILinkedPageObjectSpecifiable> {
  constructor() {
    super(
      "parent-alert",
      new LinkedPageObjectTranslator({
        isItemBeanEnable: b => b["@item-type"] === "1",
        complementBean: b => b["@item-type"] = "1",
      }));
  }
}
